/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Linkusedtitle3Inputs */

const en_signin_linkusedtitle3 = /** @type {(inputs: Signin_Linkusedtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link already used`)
};

const fr_signin_linkusedtitle3 = /** @type {(inputs: Signin_Linkusedtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lien déjà utilisé`)
};

/**
* | output |
* | --- |
* | "Link already used" |
*
* @param {Signin_Linkusedtitle3Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const signin_linkusedtitle3 = /** @type {((inputs?: Signin_Linkusedtitle3Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Linkusedtitle3Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signin_linkusedtitle3(inputs)
	return fr_signin_linkusedtitle3(inputs)
});
export { signin_linkusedtitle3 as "signIn_linkUsedTitle" }